import { Button } from '@chakra-ui/react';
import { ReactComponent as CrownDownloadIcon } from 'assets/icons/crown_upgrade_fill.svg';
import { UPGRADE_REDIRECT_BIZ_LINK, UPGRADE_REDIRECT_LINK } from 'constants/links';
import { UPGRADE } from 'constants/mixpanel';
import { useChameleon } from 'libs/third-party/Chameleon';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { getUserPlanProperty } from 'libs/third-party/Mixpanel/mixpanel.helper';
import { UserType, UserTypes } from 'modules/User';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { setAnalyticsUpgradeFeatureProp } from 'utils/sessionStorage';

import { DefaultTabNumber } from './components/DownloadModal/DownloadModal.types';

const UPGRADE_REDIRECT_LINKS_BY_TYPE: { [key: string]: string } = {
  [UserTypes.Free]: UPGRADE_REDIRECT_LINK,
  [UserTypes.Premium]: UPGRADE_REDIRECT_BIZ_LINK,
};

const UPGRADE_TEXT_LABEL: { [key: string]: string } = {
  [UserTypes.Free]: 'Premium',
  [UserTypes.Premium]: 'Business',
};

export const ShareUpgradeButton = memo(
  ({ userType, tabPanel }: { userType: UserType; tabPanel?: number }): ReactElement | null => {
    const { t } = useTranslation('common_navbar');
    const { trackChameleon } = useChameleon();
    const eventFeature =
      tabPanel === DefaultTabNumber.Share
        ? UPGRADE.feature.Share
        : tabPanel === DefaultTabNumber.Preview
        ? UPGRADE.feature.Preview
        : UPGRADE.feature.Embed;

    // Redirect to subscription page
    const onClick = () => {
      Mixpanel.track(UPGRADE.eventName, {
        Feature: eventFeature,
        'User Plan': getUserPlanProperty(userType),
      });
      trackChameleon(UPGRADE.eventName);

      setAnalyticsUpgradeFeatureProp(eventFeature);
      window.open(UPGRADE_REDIRECT_LINKS_BY_TYPE[userType] || UPGRADE_REDIRECT_LINK, '_self');
    };

    const testId = 'navbar-upgrade-button';
    const label = 'Upgrade';
    const userTypeLabel = UPGRADE_TEXT_LABEL[userType];

    return (
      <Button
        variant='upgrade'
        bg={userType === UserTypes.Free ? 'avatar.3' : 'upgrade.blue.500'}
        _hover={{ bg: userType === UserTypes.Free ? 'avatar.4' : 'blue.500' }}
        borderRadius={'md'}
        gap={3}
        size='sm'
        data-testid={testId}
        aria-label={label}
        onClick={onClick}
        h={9}
      >
        <CrownDownloadIcon />
        {t('navbar.upgrade-share-button', { userType: userTypeLabel })}
      </Button>
    );
  },
);

ShareUpgradeButton.displayName = 'ShareUpgradeButton';
